import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, ListItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CancelIcon, ConfirmIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { getDocumentTypeById } from 'store/system/selectors';

import { LoanApplicationDocumentsTestIds } from '../../LoanApplicationDocuments.testIds';

const getStyles = ({ palette }, { isChosen, isReady }) => {
  const isDark = palette.type === 'dark';

  return {
    documentType: {
      width: '100%',
      height: '50px',
      color: isDark || isChosen ? palette.text.primary : palette.common.white,
      border: `1px solid ${palette.divider}`,
      backgroundColor: isChosen ? palette.action.selected : palette.primary.main,
      cursor: 'pointer',
    },
    statusIcon: {
      right: '0.8rem',
      color: isReady ? palette.success.main : palette.error.main,
    },
  };
};

const MissingDocumentType = ({
  documentTypeId,
  setChosenMissingDocumentTypeId,
  isChosen,
  isReady,
}) => {
  const theme = useTheme();
  const classes = useMemo(
    () => getStyles(theme, { isChosen, isReady }),
    [theme, isChosen, isReady],
  );

  const { documentTypeName } = useSelector(getDocumentTypeById(documentTypeId));

  const onClick = useCallback(
    () => setChosenMissingDocumentTypeId(documentTypeId),
    [documentTypeId, setChosenMissingDocumentTypeId],
  );

  return (
    <ListItem
      className="flex justify-between"
      data-testid={LoanApplicationDocumentsTestIds.getMissingDocumentUploadId(documentTypeId)}
      sx={classes.documentType}
      onClick={onClick}
    >
      {documentTypeName}
      <Box className="absolute" sx={classes.statusIcon}>
        {isReady ? <ConfirmIcon size={IconSize[24]} /> : <CancelIcon size={IconSize[24]} />}
      </Box>
    </ListItem>
  );
};

MissingDocumentType.propTypes = {
  documentTypeId: PropTypes.string.isRequired,
  isChosen: PropTypes.bool.isRequired,
  isReady: PropTypes.bool.isRequired,
  setChosenMissingDocumentTypeId: PropTypes.func.isRequired,
};

export default MissingDocumentType;
